import { Alert, breakpoints, Table, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  overflow: auto;
`;

export const Title = styled.h2`
  ${typographyV2.titleMd}
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-soft);

  @media ${breakpoints.md} {
    padding-left: 0;
  }
`;

export const StyledTable = styled(Table)`
  padding: 0 4px;

  & td,
  th {
    padding: 8px;
  }

  @media ${breakpoints.md} {
    padding: 0;

    & td,
    th {
      padding: 12px;
    }
  }
`;

export const TableHeaderTooltipText = styled.span`
  border-bottom: 1px dashed var(--border-default);
`;

export const StyledAlert = styled(Alert)`
  width: 100%;
  margin-bottom: 12px;
`;
